export enum SponsorType{
    HoleSponsor = 1,
    CartSponsor = 2,
    Donation = 3,
    Team = 4,
    Other = 5
}